export var ROCKET_POOL_DEPOSIT_POOL = [
    {
        address: '0xDD3f50F8A6CafbE9b31a427582963f465E745AF8',
        chainId: 1,
    },
];
export var ROCKET_POOL_ERC20 = [
    {
        address: '0xae78736Cd615f374D3085123A210448E74Fc6393',
        chainId: 1,
    },
];
